import { Capacitor } from '@capacitor/core';

/**
 * Retour haptique léger pour l'app native — no-op sur le web.
 * Le plugin `@capacitor/haptics` est chargé par import dynamique et n'entre
 * donc jamais dans le bundle web.
 */

type HapticStyle = 'light' | 'medium' | 'heavy';

export async function hapticImpact(style: HapticStyle = 'light'): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
    const map = {
      light: ImpactStyle.Light,
      medium: ImpactStyle.Medium,
      heavy: ImpactStyle.Heavy,
    } as const;
    await Haptics.impact({ style: map[style] });
  } catch {
    /* ignore */
  }
}

export async function hapticSelection(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { Haptics } = await import('@capacitor/haptics');
    await Haptics.selectionStart();
    await Haptics.selectionEnd();
  } catch {
    /* ignore */
  }
}

export async function hapticNotification(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { Haptics, NotificationType } = await import('@capacitor/haptics');
    await Haptics.notification({ type: NotificationType.Success });
  } catch {
    /* ignore */
  }
}
